var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "message-container d-flex justify-content-center mb-2 incoming call inbound",
    },
    [
      _c("div", { staticClass: "message" }, [
        _c(
          "div",
          {
            staticClass: "content d-flex align-items-center",
            style: _vm.styles,
          },
          [
            _c("div", { staticClass: "call__info" }, [
              _c("div", { staticClass: "call__type d-block mb-1" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.typeText) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "call__duration d-block" }, [
                _c("i", { staticClass: "fas fa-arrow-down" }),
                _vm._v(" " + _vm._s(_vm.duration) + "\n                "),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer text-black-50" }, [
          _vm._v(_vm._s(_vm.beginAtFormatted)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "call-button" }, [
      _c("i", { staticClass: "fas fa-phone-alt" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }